import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import UrlMixin from '@/components/query/url-mixin';
import MainMenuComplexTabsMixin from '@/views/layout/navigation/mixins/main-menu-complex-tabs-mixin';
import { AclMixin } from '@/components/acl/acl-mixin';
import { Route } from 'vue-router';
import ColumnsService from '@/services/columns';
const _ =  require('lodash');

export enum MainMenuLayoutType {
  tab = 0,
  tabCustom,
  delimiter
}

export interface MainMenuLayoutTab extends Bemob.ListItemBase<MainMenuLayoutTab> {
  type: MainMenuLayoutType;
}

@Component
export default class MainMenuGroupingMixin extends mixins(UrlMixin, MainMenuComplexTabsMixin, AclMixin)  {
  menuOpened: {[type: string]: boolean} = {};

  get activeItem(): MainMenuLayoutTab {  
    const result = this.tabsLayout
      .filter((item) => item.active)
      .map((item) => {
        return !item.subItems 
          ? item
          : item.subItems
            .filter((subItem) => subItem.active)
            .reduce((acc, subItem) => ({ 
              ...subItem,
              icon: item.icon
            }), null);
      })
      .reduce((acc, item) => item, null);

    return result
      ? result 
      : this.tabsLayout[0];
  }
    
  get mainMenuLayoutTypeEnum() {
    return {
      tab: MainMenuLayoutType.tab,
      tabCustom: MainMenuLayoutType.tabCustom,
      delimiter: MainMenuLayoutType.delimiter,
    };
  }

  get mainPlainLayout(): MainMenuLayoutTab[] {

    return _.get(this.complexTabsData, 'mainPlain',[]).map((data) => ({
      type: MainMenuLayoutType.tab,
      key: data.name,
      icon: data.icon,
      title: data.title,
      active: data.name === this.computedType,
      showCondition: !this.isHidden(data.name),
      click: (event: any) => {
        this.handleMenuClick(event, () => this.getLink(data.name, {
          isReport: this.isReport(),
        }))
      },
      link: this.getLink(data.name, {
        isReport: this.isReport(),
      }),
    } as MainMenuLayoutTab));
  }

  get conversionsTabLayout(): MainMenuLayoutTab[] {
    const result: MainMenuLayoutTab = {
      type: MainMenuLayoutType.tab,
      key: 'conversions',
      icon: this.tabsMeta['conversions'].icon,
      title: this.t('Conversions'),
      active: this.computedType === 'conversions',
      link: this.conversionsLink,
      showCondition: (
          !this.$store.state.user.hideProfit ||
          this.$store.state.user.showConversions 
        )
        && !!this.complexTabsData.conversions,
      click: (event: any) => {
        this.handleMenuClick(event, this.conversionsLink)
      }
    };

    return [ result ];
  }

  get errorsTabLayout(): MainMenuLayoutTab[] {
    const result: MainMenuLayoutTab = {
      type: MainMenuLayoutType.tab,
      key: 'errors',
      icon: this.tabsMeta['errors'].icon,
      title: this.t('Errors'),
      active: this.computedType === 'errors',
      showCondition: !!this.complexTabsData.errors,
      link: this.errorsLink,
      click: (event: any) => {
        this.handleMenuClick(event, this.errorsLink)
      }
    };

    return [ result ];
  }

  get postbacksTabLayout(): MainMenuLayoutTab[] {
    const result: MainMenuLayoutTab = {
      type: MainMenuLayoutType.tab,
      key: 'postbacks',
      icon: this.tabsMeta['postbacks'].icon,
      title: this.t('Postbacks'),
      active: this.computedType === 'postbacks',
      showCondition: !this.$store.state.user.hideProfit && !!this.complexTabsData.postbacks && this.isUserOrMemberAdmin,
      link: this.postbacksLink,
      click: (event: any) => {
        this.handleMenuClick(event, this.postbacksLink)
      }
    };

    return [ result ];
  }

  get dashboardTabLayout(): MainMenuLayoutTab[] {
    const result: MainMenuLayoutTab = {
      type: MainMenuLayoutType.tab,
      key: 'dashboard',
      icon: 'fas fa-tachometer-alt',
      title: this.t('Dashboard stub'),
      active: this.$route.path.includes('/app/dashboard/'),
      showCondition: true,
      link: this.getDashboardLink(),
      click: (event: any) => {
        this.$router.push(this.getDashboardLink());
      }
    };

    return [ result ];
  }

  get complexTabsLayout(): MainMenuLayoutTab[] {
    return this.complexTabs.map((complexTab) => ({
      type: MainMenuLayoutType.tab,
      key: complexTab.name,
      icon:  complexTab.icon,
      title: complexTab.data.title,
      active: complexTab.data.isActive || this.menuOpened[complexTab.name],
      showCondition: true,
      subItems: this.complexTabsData[complexTab.name]
        .filter((data) => !data.hideInMenu)
        .map((data) => ({
          type: MainMenuLayoutType.tab,
          key: data.name,
          title: data.title,
          active: data.name === this.computedType,
          showCondition: !data.hideInMenu,
          link: this.handleComplexMenuClickCb(data)(),
          click: (event: any) => this.handleComplexMenuClick(event, data)
        } as MainMenuLayoutTab))
    } as MainMenuLayoutTab));
  }

  get customTabsLayoutData(): MainMenuLayoutTab {
    return {
      type: MainMenuLayoutType.tabCustom,
      key: 'custom',
      icon:  'fas fa-cogs',
      title: this.curentCustomGroup
        ? this.curentCustomGroup.title
        : this.t('Custom'),
      active: !!this.curentCustomGroup || this.menuOpened['custom'],
      showCondition: !!this.isShowCustomGroup,
      subItems: this.complexTabsData.custom
        .map((data) => ({
          type: MainMenuLayoutType.tabCustom,
          key: data.name,
          title: data.title,
          active: data.name === this.computedType,
          showCondition: !data.hideInMenu,
          link: this.getLink(data.name, {
            isReport: this.isReport(),
          }),
          click: (event: any) => { 
            this.handleMenuClick(event, this.getLink(data.name, {
            isReport: this.isReport(),
          }))
        },
          meta: data.meta
        } as MainMenuLayoutTab))
    }
  }

  get customTabsLayout(): MainMenuLayoutTab[] {
    return this.isShowCustomGroup 
      ? [ this.customTabsLayoutData ] 
      : [];
  }

  genDelimiter(): MainMenuLayoutTab {
    return {
      key: 'delimiter_1',
      type: MainMenuLayoutType.delimiter
    };
  }


  get reportTabsLayout(): MainMenuLayoutTab[] {
    return this.mainPlainLayout
      .concat(this.genDelimiter())
      .concat(this.conversionsTabLayout)
      .concat(this.postbacksTabLayout)
      .concat(this.complexTabsLayout)
      .concat(this.customTabsLayout)
      .concat(this.errorsTabLayout);
  }

  get tabsLayout(): MainMenuLayoutTab[] {
    switch(this.$route.meta.menuType) {
      case 'dashboard': 
        return this.dashboardTabsLayout;
      case 'settings':
        return this.settingsTabsLayout;
      case 'storybook':
        return this.storybookTabsLayout;
      default: 
        return this.reportTabsLayout;
    }
  }

  get storybookTabsLayout() {
    const result: MainMenuLayoutTab = {
      type: MainMenuLayoutType.tab,
      key: 'storybook',
      icon: 'fas fa-tachometer-alt',
      title: this.t('Dashboard stub'),
      active: this.$route.path.includes('/app/storybook/'),
      showCondition: false,
      link: this.getDashboardLink(),
      click: (event: any) => {
        this.$router.push(this.getDashboardLink());
      }
    };

    return [ result ];
  }


  getRouteParams(link: any) {
    return {
      link: link,
      click: (event: any) => {
        this.$router.push(link);
      }
    }
  }

  get dashboardTabsLayout(): MainMenuLayoutTab[] {
    return this.dashboardTabLayout;
  }

  get settingsTabsLayout(): MainMenuLayoutTab[] {
    const result: MainMenuLayoutTab[] = [
      {
        type: MainMenuLayoutType.tab,
        key: 'general',
        icon: 'fas fa-cog',
        title: this.t('General'),
        active: this.$route.name === 'app.profile',
        showCondition: true,
        ...this.getRouteParams({
          name: 'app.profile'
        })
      },
      {
        type: MainMenuLayoutType.tab,
        key: 'security',
        icon: 'fas fa-shield-alt',
        title: this.t('Security'),
        active: this.$route.name === 'app.profile.security',
        showCondition: true,
        ...this.getRouteParams({
          name: 'app.profile.security'
        })
      },
      {
        type: MainMenuLayoutType.tab,
        key: 'domains',
        icon: 'fas fa-globe-asia',
        title: this.t('Domains'),
        active: this.$route.name === 'app.profile.domains',
        showCondition: this.canAccessPage('profile.domains'),
        ...this.getRouteParams({
          name: 'app.profile.domains'
        })
      },
      {
        type: MainMenuLayoutType.tab,
        key: 'tracking-links',
        icon: 'fas fa-link',
        title: this.t('Tracking URLs'),
        active: this.$route.name === 'app.profile.tracking-links',
        showCondition: true,
        ...this.getRouteParams({
          name: 'app.profile.tracking-links'
        })
      },
      {
        type: MainMenuLayoutType.tab,
        key: 'upload-conversions',
        icon: 'fas fa-cloud-upload-alt',
        title: this.t('Upload Conversions'),
        active: this.$route.name === 'app.profile.upload-conversions',
        showCondition: this.canAccessPage('profile.upload-conversions'),
        ...this.getRouteParams({
          name: 'app.profile.upload-conversions'
        })
      },
      {
        type: MainMenuLayoutType.tab,
        key: 'bot-filters',
        icon: 'fas fa-ban',
        title: this.t('Bot Filters'),
        active: this.$route.name === 'app.profile.bot-filters',
        showCondition: this.canAccessPage('profile.bot-filters'),
        ...this.getRouteParams({
          name: 'app.profile.bot-filters'
        })
      },
      {
        type: MainMenuLayoutType.tab,
        key: 'subscription',
        icon: 'fas fa-credit-card',
        title: this.t('Subscription'),
        active: this.$route.name === 'app.profile.subscription',
        showCondition: this.canAccessPage('profile.subscription'),
        ...this.getRouteParams({
          name: 'app.profile.subscription'
        })
      },
      {
        type: MainMenuLayoutType.tab,
        key: 'referral-program',
        icon: 'fas fa-users',
        title: this.t('Referral Program'),
        active: this.$route.name === 'app.profile.referral-program',
        showCondition: this.canAccessPage('profile.referral-program'),
        ...this.getRouteParams({
          name: 'app.profile.referral-program'
        })
      },
      {
        type: MainMenuLayoutType.tab,
        key: 'integrations',
        icon: 'fas fa-file-import',
        title: this.t('Integrations'),
        active: this.$route.name === 'app.profile.integrations',
        showCondition: this.canAccessPage('profile.integrations'),
        ...this.getRouteParams({
          name: 'app.profile.integrations'
        })
      },
      {
        type: MainMenuLayoutType.tab,
        key: 'multi-user-access',
        icon: 'fas fa-users-cog',
        title: this.t('Multi-User Access'),
        active: this.$route.name === 'app.profile.multi-user-access',
        showCondition: this.canAccessPage('profile.multi-user-access'),
        ...this.getRouteParams({
          name: 'app.profile.multi-user-access'
        })
      },
      {
        type: MainMenuLayoutType.tab,
        key: 'custom-conversions',
        icon: 'fas fa-file-invoice-dollar',
        title: this.t('Custom Conversions'),
        active: this.$route.name === 'app.profile.custom-conversions',
        showCondition: this.canAccessPage('profile.custom-conversions'),
        ...this.getRouteParams({
          name: 'app.profile.custom-conversions'
        })
      },
      {
        type: MainMenuLayoutType.tab,
        key: 'custom-conversions',
        icon: 'fas fa-file-chart-line',
        title: this.t('Plans Description'),
        active: this.$route.name === 'app.profile.plan-description',
        showCondition: this.canAccessPage('profile.plan-description'),
        ...this.getRouteParams({
          name: 'app.profile.plan-description'
        })
      },
    ];

    return result;
  }  

  get curentCustomGroup() {
    return this.complexTabsData.custom
      ? this.complexTabsData.custom.find((e) => e.name.includes(this.$route.params.type)) 
      : null;
  }

  get tabsLayoutFlat() {
    const result: {[type: string]: MainMenuLayoutTab} = {};
    this.tabsLayout.forEach((item) => {
      if(!item.subItems) {
        result[item.key] = item;
      } else {
        item.subItems.forEach((subItem) => {
          result[subItem.key] = subItem;
        });
      }
    });
    return result;
  }

  handleMenuClick(event: any, link: Route | Function, saveReportSimpleColumns: boolean = false) {
    const which = event
      ? event.which 
      : 1;

    if(which) {
      const { bus } = this;
      const { commit } = this.$store;

      if(typeof link === 'function') {
        link = link() as Route;
      }

      const currentType = ColumnsService.type;
      const nextType = ColumnsService.getType(link);

      if(currentType === nextType) {
        return;
      }

      commit('loading', true);
      commit('tableMenuOverride', nextType);

      bus.emit('freeze-table');

      setTimeout(() => {
        this.$router.push(link);

        setTimeout(() => {
          this.$nextTick(() => {
            bus.emit('get-report');
          });
        }, 10);
      });
    }

    return false;
  }

  handleComplexMenuClickCb(data: any) {
    const linkCb = data.isLive
      ? () => this.getLivesLink(data.name)
      : () => this.getLink(data.name, {
        isReport: this.isReport(),
      })

    return linkCb;
  }

  handleComplexMenuClick(event: any, data: any) {
    const linkCb = this.handleComplexMenuClickCb(data);
    this.handleMenuClick(event, linkCb, true);
  }

  get isShowCustomGroup() {
    return this.customGroupsShowCondition;
  }
}
